import React, { useState, useEffect, useMemo } from "react";
import TrainersNavbar from './TrainerNavbar';
import '../styles/MessageComponent.css'; // Import CSS file for MessageComponent

const TrainerMessage = ({ allRows = [] }) => { // Default to an empty array if allRows is undefined
  const [to, setTo] = useState("");
  const [message, setMessage] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [username, setUsername] = useState("");

  const groups = useMemo(() => ["Excellent", "Capable", "Idle"], []);
  const departments = useMemo(() => ["BCA", "BSC IT", "BSC CS", "BSC CT"], []);

  useEffect(() => {
    // Fetch the username from local storage
    const storedUsername = localStorage.getItem('trainerName');
    setUsername(storedUsername);

    if (to) {
      const lowerCaseTo = to.toLowerCase();
      const departmentSuggestions = departments.filter(department => 
        department.toLowerCase().includes(lowerCaseTo)
      );
      const groupSuggestions = groups.filter(group => 
        group.toLowerCase().includes(lowerCaseTo)
      );
      const rollNumberSuggestions = allRows.filter(row => 
        row[0].toLowerCase().includes(lowerCaseTo) || // Roll number
        row[5].toLowerCase().includes(lowerCaseTo) // Department
      ).map(row => row[0]); // Map to roll numbers

      setSuggestions([...departmentSuggestions, ...groupSuggestions, ...rollNumberSuggestions]);
    } else {
      setSuggestions([]);
    }
  }, [to, allRows, groups, departments]);

  const handleAddRecipient = (suggestion) => {
    setRecipients([...recipients, suggestion]);
    setTo("");
    setSuggestions([]);
  };

  const handleRemoveRecipient = (index) => {
    setRecipients(recipients.filter((_, i) => i !== index));
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!recipients.length || !message) {
      setError('All fields are required.');
      return;
    }

    const timestamp = new Date().toISOString();
    const sender = username; // Use the username as the sender

    try {
      const response = await fetch('http://localhost:3009/api/messages/send-trainer-message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recipients, message, timestamp, sender }),
      });

      if (response.ok) {
        const result = await response.json();
        setSuccess('Message sent successfully!');
        console.log('Message sent with ID:', result.insertedId);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to send message.');
        console.error('Error response from server:', errorData);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setError('Unable to send message. Please try again.');
    }
  };

  return (
    <div>
      <TrainersNavbar />
      <div className="message-container">
        <h3>Send Message</h3>
        <form onSubmit={handleSendMessage}>
          <div className="form-group">
            <label htmlFor="to">To:</label>
            <input
              type="text"
              id="to"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              placeholder="Enter roll numbers, groups, or departments"
            />
            {suggestions.length > 0 && (
              <ul className="suggestions-list">
                {suggestions.map((suggestion, index) => (
                  <li key={index} onClick={() => handleAddRecipient(suggestion)}>
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}
            <div className="recipients-list">
              {recipients.map((recipient, index) => (
                <span key={index} className="recipient">
                  {recipient}
                  <button onClick={() => handleRemoveRecipient(index)} className="remove-recipient-button">x</button>
                </span>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message"
            ></textarea>
          </div>
          <button type="submit" className="send-button">Send</button>
        </form>
        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}
      </div>
    </div>
  );
};

export default TrainerMessage;
